class WeglotInternationalization extends HTMLElement {
    constructor() {
        super();
    }

    connectedCallback() {
        this.setVariables();
        this.init();
    }

    setVariables() {
        this.currentLanguage = document.documentElement.getAttribute('lang');
        this.excludedUrlJson = this.querySelector('[data-excluded-urls-json]') || '[]';
        this.excludedUrls = JSON.parse(this.excludedUrlJson.textContent);
    }

    init() {
        try {
            for (let i = 0; i < this.excludedUrls.length; i++) {
                let excludedUrl = this.excludedUrls[i].excludedUrl;
                let redirectedUrl = this.excludedUrls[i].redirectedUrl;
                let excludedLanguages = this.excludedUrls[i].excludedLanguages;

                if (window.location.href.includes(excludedUrl) && excludedLanguages.includes(this.currentLanguage)) {
                    window.location.href = redirectedUrl;
                }   
            } 
        } catch (error) { 
            console.log(error);
        }
    }
}

customElements.define('weglot-internationalization', WeglotInternationalization);